import { z } from 'zod';

const MensajeCompraAgilUiSchema = z.object({
  id: z.string(),
  fecha_creacion: z.string(),
  mensaje: z.string(),
  activo: z.boolean(),
  usuario_autor: z.string(),
});

export const ListarMensajesComprasAgilesUiSchema = z.array(MensajeCompraAgilUiSchema);

export type ListarMensajesComprasAgilesUi = z.infer<typeof ListarMensajesComprasAgilesUiSchema>;
export type MensajeCompraAgilUi = z.infer<typeof MensajeCompraAgilUiSchema>; 